/**
 * 账户信息
 */
<template>
    <div>
      <div class="login-title">四川省知识产权发展研究中心专利申请预评估系统(管理端)</div>
      <div class="login-title-en">Sichuan Intellectual Property Development Research Center Patent Application Pre-evaluation System</div>
      <div class="eval-tab">
         <div :class="checkTab == 1 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpAccount()">账户管理</div>
         <div :class="checkTab == 2 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpCase()">案件管理</div>
         <div :class="checkTab == 3 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpPersonCenter()">个人中心</div>
      </div>
    </div>
</template>
<script>
import { 
    getAdminPermission,
    getAdminBtn
   } from '../api/evalMG'
    export default {
        name: 'sysNav',
        data() {
            return {
             checkTab: '',
            }
        },
        created() {
            let path = this.$route.path
            if(path == '/system/account'){
                this.checkTab = 1
            }
            if(path == '/system/case'){
                this.checkTab = 2
            }
            if(path == '/system/personCenter'){
                this.checkTab = 3
            }
            this.getAdminPermissionData()
            this.getAdminBtnData()
        },
        methods: {
         // 跳转账户管理
         jumpAccount(){
            this.$router.push({ path: '/system/account'});
         },
         // 跳转案件管理
         jumpCase(){
            this.$router.push({ path: '/system/case'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/system/personCenter'});
         },
         // 查询账户权限菜单
         getAdminPermissionData(){
            let param = {}
            getAdminPermission(param)
            .then(res=>{
                let menu = res.data
                localStorage.setItem('menuAuth',JSON.stringify(menu))
            })
         },
         // 查询账户权限按钮
         getAdminBtnData(){
            let param = {}
            getAdminBtn(param)
            .then(res=>{
                if(res.code == 200){
                    // 将权限按钮存入缓存
                    let btn = res.data
                    localStorage.setItem('btnAuth',JSON.stringify(btn))
                }
            })
         }
        }
    }
</script>
<style scoped>
 .login-title {
    font-size: 36px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-tab {
   width: 680px;
   display: flex;
   justify-content: space-between;
   margin: 40px auto;
  }
  .eval-tab-item {
   width: 200px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   font-size: 18px;
   font-weight: 700;
   border-radius: 46px;
   background-color: #fff;
   cursor: pointer;
   filter: drop-shadow(0 4px 2px rgba(0,0,0,0.25));
  }
  .eval-tab-item-active {
   width: 200px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   font-size: 18px;
   font-weight: 700;
   border-radius: 46px;
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
   filter: drop-shadow(0 4px 2px rgba(0,0,0,0.25));
  }
</style>


// WEBPACK FOOTER //
// src/components/sysNav.vue